module.exports = __webpack_public_path__ + "log-in/img/loading_anim_transparent.2f68bfe7.gif";